// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7500b00d","513":"f3d64954","703":"4667dcb3"}[chunkId] + ".chunk.js";
};